<div
  class="flex flex--space-between wrap border rounded-large white-bg overflow-hidden ms-medium-b"
  [class.heather-600-border]="active"
  [class.border-2]="active"
>
  <div class="heather-700-bg flex flex--self-stretch ps-xsmall icon-container">
    @for (icon of [SvgLibraryIcon.SEAT_OR_ECONOMY, SvgLibraryIcon.PLUS, SvgLibraryIcon.WIFI]; track icon) {
      <fcom-icon class="icon-small white-text flex--self-center" [name]="icon"></fcom-icon>
    }
  </div>
  <div class="flex flex--basis-full text-container">
    <p class="font-body-1 bold-type flex--self-center underline-dotted ps-xsmall-l">
      {{ 'ancillaries.bundle.toggle.title' | finLocalization }}
    </p>
    @if (wifiVariant$ | async) {
      <p
        class="font-body-2 flex--self-center ps-xsmall-l"
        data-testid="seat-bundle-toggle-description"
        [innerHTML]="'ancillaries.bundle.toggle.description.' + (wifiVariant$ | async) | finLocalization"
      ></p>
    }
  </div>
  <div class="flex flex--space-between ms-xxsmall">
    <div class="flex--self-center tag-container">
      <fcom-tag [theme]="TagTheme.POPULAR">-{{ discountPercentage }}%</fcom-tag>
    </div>
    <fcom-toggle-switch
      [status]="active ? ToggleSwitchStatus.ACTIVE : ToggleSwitchStatus.UNCHECKED"
      (statusChange)="emitToggle($event.status === ToggleSwitchStatus.UNCHECKED)"
      class="ps-xsmall-l flex--self-center"
    ></fcom-toggle-switch>
  </div>
</div>
